import { Radio, Stack, TableCell, Typography, useTheme } from "@mui/material";
import { TableRow } from "@mui/material";
import { RtStructOut } from "@providers/hop-ord-server/api";
import { CustomTheme } from "@mui/material/styles";
import { useMemo } from "react";
import TextOverflowTooltip from "@components/TextOverflowTooltip/TextOverflowTooltip";
import { toLocaleDateTimeString } from "@utils";

const RTStructRow = ({
  data,
  onSelect,
  selected,
  isLastRow,
}: {
  data: RtStructOut;
  onSelect: (id: number) => void;
  selected: boolean;
  isLastRow: boolean;
}) => {
  // Get localized date times
  const { seriesDatetime, ctSeriesDatetime } = useMemo(() => {
    try {
      let seriesDatetime = "-";
      let ctSeriesDatetime = "-";
      if (data.seriesDatetime) {
        seriesDatetime = toLocaleDateTimeString(data.seriesDatetime);
      }
      if (data.ctSeriesDatetime) {
        ctSeriesDatetime = toLocaleDateTimeString(data.ctSeriesDatetime);
      }
      return { seriesDatetime, ctSeriesDatetime };
    } catch {
      return { seriesDatetime: "", ctSeriesDatetime: "" };
    }
  }, [data]);

  const cellStyle = isLastRow ? { borderBottom: "none" } : {};

  const theme = useTheme<CustomTheme>();

  return (
    <TableRow
      onClick={() => onSelect(data.id)}
      selected={selected}
      hover
      sx={{
        cursor: "pointer",
        transition: theme.transitions.create(["background-color"], {
          duration: theme.transitions.duration.standard,
          easing: theme.transitions.easing.easeInOut,
        }),
      }}
    >
      <TableCell sx={{ width: "40%", minWidth: "40%", ...cellStyle }}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1,
          }}
        >
          <Radio checked={selected} />

          <Stack direction="column">
            <TextOverflowTooltip
              variant="body2"
              noWrap={false}
              multilineText={true}
              arrow
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
              }}
            >
              {data.seriesDescription ? data.seriesDescription : "-"}
            </TextOverflowTooltip>

            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
              }}
            >
              {seriesDatetime ? seriesDatetime : "-"}
            </Typography>
          </Stack>
        </Stack>
      </TableCell>
      <TableCell sx={{ width: "40%", minWidth: "40%", ...cellStyle }}>
        <TextOverflowTooltip
          variant="body2"
          noWrap={false}
          multilineText={true}
          arrow
          sx={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 1,
          }}
        >
          {data.ctSeriesDescription ? data.ctSeriesDescription : "-"}
        </TextOverflowTooltip>

        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
          }}
        >
          {ctSeriesDatetime ? ctSeriesDatetime : "-"}
        </Typography>
      </TableCell>
      <TableCell sx={{ width: "20%", minWidth: "20%", ...cellStyle }}>
        {data.numberOfSlices ? data.numberOfSlices : "-"}
      </TableCell>
    </TableRow>
  );
};

export default RTStructRow;
